import React from 'react';
import * as S from './styles';

export interface MenuHeaderProps {
  children?: React.ReactNode;
  className?: string;
}

export const MenuHeader: React.FC<MenuHeaderProps> = ({
  children,
  className,
}) => <S.Root className={className}>{children}</S.Root>;

export default MenuHeader;
